import React, { useEffect, useState } from 'react'

import { Container } from './styles'
import Box from '@mui/material/Box'
import { Card, TextField, Typography, Grid, Button, Modal } from '@mui/material'
import ConfirmationModal from '../../components/ui/ConfirmationModal'
// import { useModalContext } from '../../contexts/ModalContext'
import 'react-data-table-component-extensions/dist/index.css'
import * as MechanicsService from '../../services/mechanics'

const GasStationsPrices = () => {
    // const { setModal } = useModalContext()
    const [data, setData] = useState([])
    const [prices, setPrices] = useState({})
    const [message, setMessage] = useState('')
    const [messageType, setMessageType] = useState('')
    const [expandedImage, setExpandedImage] = useState(null)
    const [imageModalOpen, setImageModalOpen] = useState(false)
    const [removeModal, setRemoveModal] = useState({ open: false, establishmentId: null })

    useEffect(() => {
        fetchTableData()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const showMessage = (text, type) => {
        setMessage(text)
        setMessageType(type)
        setTimeout(() => {
            setMessage('')
            setMessageType('')
        }, 3000)
    }

    async function fetchTableData() {
        try {
            const response = await MechanicsService.getAllPriceImages()
            console.log(response)
            setData(response)
            // Initialize prices state for each establishment
            const initialPrices = {}
            response.forEach((establishment) => {
                const priceValues = {
                    gasoline: '',
                    aditivada: '',
                    diesel: '',
                    alcohol: '',
                    gnv: ''
                }
                // Set initial values from existing prices
                establishment.prices?.forEach((price) => {
                    if (price.description === 'GASOLINA') {
                        priceValues.gasComum = price.price.toString().replace(',', '.')
                    }
                    if (price.description === 'ADITIVADA') {
                        priceValues.gasAditivada = price.price.toString().replace(',', '.')
                    }
                    if (price.description === 'DIESEL') {
                        priceValues.diesel = price.price.toString().replace(',', '.')
                    }
                    if (price.description === 'ETANOL') {
                        priceValues.etanol = price.price.toString().replace(',', '.')
                    }
                    if (price.description === 'GNV') {
                        priceValues.gnv = price.price.toString().replace(',', '.')
                    }
                })

                initialPrices[establishment.establishmentId] = priceValues
            })
            setPrices(initialPrices)
        } catch (error) {
            console.error('Error fetching data:', error)
            showMessage('Erro ao carregar dados!', 'error')
        }
    }

    const handlePriceChange = (establishmentId, type, value) => {
        // Ensure value uses dot as decimal separator
        const formattedValue = value.replace(',', '.')
        setPrices((prev) => ({
            ...prev,
            [establishmentId]: {
                ...prev[establishmentId],
                [type]: formattedValue
            }
        }))
    }

    const handleImageClick = (imageUrl, establishmentName) => {
        setExpandedImage({ imageUrl, establishmentName })
        setImageModalOpen(true)
    }

    const handleSubmit = async (establishmentId) => {
        const establishmentPrices = prices[establishmentId]
        const pricesList = [
            {
                description: 'GASOLINA',
                price: parseFloat(establishmentPrices.gasComum)
            },
            {
                description: 'ADITIVADA',
                price: parseFloat(establishmentPrices.gasAditivada)
            },
            { description: 'ETANOL', price: parseFloat(establishmentPrices.etanol) },
            { description: 'DIESEL', price: parseFloat(establishmentPrices.diesel) },
            { description: 'GNV', price: parseFloat(establishmentPrices.gnv) }
        ].filter((price) => !isNaN(price.price))

        if (pricesList.length === 0) {
            showMessage('Por favor, insira pelo menos um preço válido!', 'error')
            return
        }

        try {
            await MechanicsService.savePriceImage(establishmentId, pricesList)
            showMessage('Preços atualizados com sucesso!', 'success')

            // Remove the establishment from data after successful update
            setData((prevData) => prevData.filter((est) => est.establishmentId !== establishmentId))
        } catch (error) {
            console.error('Error saving prices:', error)
            showMessage('Erro ao atualizar preços. Tente novamente!', 'error')
        }
    }

    const openRemoveModal = (establishmentId) => {
        setRemoveModal({ open: true, establishmentId })
    }

    const handleRemoveImage = async () => {
        if (!removeModal.establishmentId) return
        try {
            const result = await MechanicsService.removePriceImageByEstablishmentId(removeModal.establishmentId)
            if (result) {
                showMessage('Imagem removida com sucesso!', 'success')
                setData((prevData) => prevData.filter((est) => est.establishmentId !== removeModal.establishmentId))
            } else {
                showMessage('Não foi possível remover a imagem.', 'error')
            }
        } catch (error) {
            console.error('Error removing image:', error)
            showMessage('Erro ao remover imagem. Tente novamente!', 'error')
        } finally {
            setRemoveModal({ open: false, establishmentId: null })
        }
    }

    return (
        <Container>
            <Box mb={3} fontWeight='bold' fontSize={{ xs: 'h7.fontSize', sm: 'h6.fontSize', md: 'h5.fontSize' }}>
                Avaliação de Preços dos Postos de Gasolina
            </Box>
            <Box mb={3} fontSize={{ xs: 'h9.fontSize', sm: 'h9.fontSize', md: 'h8.fontSize' }}>
                <b>ATENÇÃO!!</b> Avalie com atenção os preços abaixo dos postos de gasolina, cada alteração impactará
                diretamente o cliente final!
            </Box>
            {message && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: 30,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        backgroundColor: messageType === 'success' ? '#4caf50' : '#f44336',
                        color: 'white',
                        padding: '10px 20px',
                        borderRadius: '4px',
                        zIndex: 9999
                    }}
                >
                    {message}
                </Box>
            )}
            <Box mt={3} mb={5}>
                {data.map((establishment) => (
                    <Card key={establishment.establishmentId} sx={{ mb: 3, p: 3 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Typography variant='h6' gutterBottom>
                                    {establishment.establishmentName}
                                </Typography>
                                <Typography variant='body1' gutterBottom>
                                    {establishment.establishmentAddress}
                                </Typography>
                                <img
                                    src={establishment.imageUrl}
                                    alt='Preços do posto'
                                    onClick={() =>
                                        handleImageClick(establishment.imageUrl, establishment.establishmentName)
                                    }
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        maxHeight: '400px',
                                        objectFit: 'contain',
                                        cursor: 'pointer',
                                        transition: 'opacity 0.2s ease-in-out'
                                    }}
                                    onMouseOver={(e) => (e.target.style.opacity = '0.8')}
                                    onMouseOut={(e) => (e.target.style.opacity = '1')}
                                />
                                <Box mt={2} display='flex' gap={1}>
                                    <Button
                                        variant='outlined'
                                        color='error'
                                        onClick={() => openRemoveModal(establishment.establishmentId)}
                                    >
                                        Remover
                                    </Button>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label='Gas. Comum'
                                            type='number'
                                            value={prices[establishment.establishmentId]?.gasComum}
                                            onChange={(e) =>
                                                handlePriceChange(
                                                    establishment.establishmentId,
                                                    'gasComum',
                                                    e.target.value
                                                )
                                            }
                                            inputProps={{
                                                step: 0.01,
                                                min: 0
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label='Gas. Aditivada'
                                            type='number'
                                            value={prices[establishment.establishmentId]?.gasAditivada}
                                            onChange={(e) =>
                                                handlePriceChange(
                                                    establishment.establishmentId,
                                                    'gasAditivada',
                                                    e.target.value
                                                )
                                            }
                                            inputProps={{
                                                step: 0.01,
                                                min: 0
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label='Etanol'
                                            type='number'
                                            value={prices[establishment.establishmentId]?.etanol}
                                            onChange={(e) =>
                                                handlePriceChange(
                                                    establishment.establishmentId,
                                                    'etanol',
                                                    e.target.value
                                                )
                                            }
                                            inputProps={{
                                                step: 0.01,
                                                min: 0
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label='Diesel'
                                            type='number'
                                            value={prices[establishment.establishmentId]?.diesel}
                                            onChange={(e) =>
                                                handlePriceChange(
                                                    establishment.establishmentId,
                                                    'diesel',
                                                    e.target.value
                                                )
                                            }
                                            inputProps={{
                                                step: 0.01,
                                                min: 0
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label='GNV'
                                            type='number'
                                            value={prices[establishment.establishmentId]?.gnv}
                                            onChange={(e) =>
                                                handlePriceChange(establishment.establishmentId, 'gnv', e.target.value)
                                            }
                                            inputProps={{
                                                step: 0.01,
                                                min: 0
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button
                                            variant='contained'
                                            color='primary'
                                            fullWidth
                                            onClick={() => handleSubmit(establishment.establishmentId)}
                                        >
                                            Atualizar Preços
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Card>
                ))}
                {data.length === 0 && (
                    <Card sx={{ mb: 3, p: 3 }}>
                        <Typography variant='h6' align='center'>
                            Nenhuma imagem de preços a analisar no momento
                        </Typography>
                    </Card>
                )}
            </Box>

            {/* Full-Screen Image Modal */}
            <Modal
                open={imageModalOpen}
                onClose={() => setImageModalOpen(false)}
                aria-labelledby='image-modal-title'
                aria-describedby='image-modal-description'
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.9)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        outline: 'none'
                    }}
                    onClick={() => setImageModalOpen(false)}
                >
                    {/* Header with establishment name and close instruction */}
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 20,
                            left: '50%',
                            transform: 'translateX(-50%)',
                            color: 'white',
                            textAlign: 'center',
                            zIndex: 1000,
                            backgroundColor: 'rgba(0, 0, 0, 0.7)',
                            padding: '10px 20px',
                            borderRadius: '8px'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Typography variant='h6' sx={{ color: 'white', mb: 1 }}>
                            {expandedImage?.establishmentName
                                ? `Preços - ${expandedImage.establishmentName}`
                                : 'Preços do Posto'}
                        </Typography>
                        <Typography variant='body2' sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                            Clique na imagem para fechar
                        </Typography>
                    </Box>

                    {/* Close button */}
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 20,
                            right: 20,
                            zIndex: 1001,
                            cursor: 'pointer',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            borderRadius: '50%',
                            width: 40,
                            height: 40,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '24px',
                            fontWeight: 'bold',
                            color: '#333',
                            '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 1)'
                            }
                        }}
                        onClick={(e) => {
                            e.stopPropagation()
                            setImageModalOpen(false)
                        }}
                    >
                        ×
                    </Box>

                    {/* Full-screen image */}
                    {expandedImage && (
                        <img
                            src={expandedImage.imageUrl}
                            alt='Preços do posto expandido'
                            onClick={() => setImageModalOpen(false)}
                            style={{
                                maxWidth: '100vw',
                                maxHeight: '100vh',
                                width: 'auto',
                                height: 'auto',
                                objectFit: 'contain',
                                cursor: 'pointer'
                            }}
                        />
                    )}
                </Box>
            </Modal>
            <ConfirmationModal
                open={removeModal.open}
                setOpen={(value) =>
                    setRemoveModal((prev) => ({ ...prev, open: value.open, establishmentId: prev.establishmentId }))
                }
                title='Deseja remover esta imagem?'
                subText='Atenção! Esta ação é irreversível.'
                handleConfirmation={handleRemoveImage}
            />
        </Container>
    )
}

export default GasStationsPrices
